import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import React, { useContext, useEffect } from 'react';

import { TListingClient } from 'types/TListing';
import EnvironmentContext from '../../../../contexts/EnvironmentContext';
import useCesSurvey from '../../../../hooks/useCesSurvey';
import { storeToRecentlyViewedVips } from '../../../../utils/storeToRecentlyViewedVips';
import storeVipViewCount from '../../../../utils/storeVipViewCount';
import Gallery from '../Gallery/Gallery';
import Classes from './Listing.scss';

type TListingProps = {
  listing: TListingClient;
};

const Listing = ({ listing }: TListingProps) => {
  const { t } = useI18nContext();
  const { userDetails: { isAdOwner = false } = {} } = useContext(EnvironmentContext);
  const { itemId, isSaved, isSavingEnabled, gallery, title, traits = [], isCarAd } = listing;
  const showMicroTipText = traits.includes('MICROTIP');
  const { loadSurvey } = useCesSurvey(isCarAd);

  useEffect(() => {
    window.addEventListener('asqSent', loadSurvey, false);
    return () => window.removeEventListener('asqSent', loadSurvey, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    storeToRecentlyViewedVips(t, listing);
    storeVipViewCount(listing.isCarAd);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={Classes.root}>
      <Gallery
        gallery={gallery}
        title={title}
        itemId={itemId}
        showMicroTipText={showMicroTipText}
        withFavoriteButton={isSavingEnabled && !isAdOwner}
        isSaved={isSaved}
        favoritedCount={listing.stats.favoritedCount}
      />
    </div>
  );
};

export default Listing;
